<div
	class="fixed inset-0 bg-secondary-800 flex items-center justify-center z-overlay px-4"
	[ngClass]="background() ? 'bg-secondary-800/50 dark:bg-secondary-100/80' : 'bg-secondary-800/0'"
	data-cy="ui-overlay"
	tabindex="-1"
	#overlayWrapper
	(click)="onBackdropClick($event)"
>
	<div
		class="max-h-[80vh] rounded-xl flex flex-col bg-white text-secondary dark:text-secondary-900 dark:bg-standard outline outline-1 -outline-offset-1 outline-secondary-200 p-8 md:p-16 {{
			styleClass()
		}}"
		[ngClass]="dark() ? 'bg-secondary text-white' : 'bg-white text-secondary'"
		[class.w-132]="!autoWidth()"
		(click)="onInnerClick($event)"
		@popupAnimation
	>
		@if (showCloseButton()) {
			<div class="flex justify-end bg-transparent md:-mt-8 md:-mr-8 -mt-4 -mr-4">
				<ui-icon
					icon="x_cross"
					size="m"
					(click)="onClose()"
					type="dark"
					[action]="true"
					tabindex="0"
					(keydown.enter)="onClose()"
					data-cy="c-overlay-close-button"
				></ui-icon>
			</div>
		}
		<div class="flex-1 overflow-hidden flex flex-col" [ngClass]="{ 'mt-3': showCloseButton() }">
			@if (header()) {
				<ui-headline type="h2">
					{{ header() }}
				</ui-headline>
			}
			<div class="flex-1 flex flex-col h-full overflow-y-auto">
				<ng-content></ng-content>
			</div>
		</div>
	</div>
</div>
